module.exports = __webpack_public_path__ + "img/00.0e14dc76.svg";